import { render } from "./DocIlinkRelation.vue?vue&type=template&id=0aa06215"
import script from "./DocIlinkRelation.vue?vue&type=script&lang=js"
export * from "./DocIlinkRelation.vue?vue&type=script&lang=js"

import "./DocIlinkRelation.vue?vue&type=style&index=0&id=0aa06215&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__